<template>
    <v-navigation-drawer
      v-model="show"
      class="custom-white"
      right
      app
      temporary
    >
            <v-list class="pt-10" dense>
                <v-list-item
                    v-for="item in navItems"
                    :key="item.title"
                    link
                    :to="!!item.to ? item.to : null"
                    @click.prevent="!item.to ? run( item.action, item ) : false"
                >
                    <v-list-item-icon>
                        <v-icon>mdi-{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            
            <v-spacer class="flex-grow-1"></v-spacer>

            
            <template v-slot:append>
                <div class="d-flex flex-fill justify-center px-5 py-10">
                    <div 
                        v-for="(item, i) in sMedias" 
                        :key="`social-medias-button-${ i }`"
                    >
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn 
                                    link
                                    text
                                    :href="item.link"
                                >
                                    <v-list-item-content
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon 
                                            :color="item.color"
                                        >mdi-{{ item.icon }}</v-icon>
                                    </v-list-item-content>
                                </v-btn>
                            </template>

                            <span>{{ item.title }}</span>
                        </v-tooltip>
                    </div>
                </div>
            </template>
    </v-navigation-drawer>
</template>

<script>

export default {
    name: 'NavigationDrawer',
    computed: {
        navItems() { return _.sortBy( this.items, [ 'index' ] ) },
    },
    data() {
        return {
            show: false,
            drawer: false,
            routesList: [],
            isMobile: false,
            fab: false,
            sMedias: [
                /* {
                    index: 1,
                    title: 'Twitter',
                    icon: 'twitter',
                    color: '#1da1f2',
                    link: process.env.VUE_APP_TWITTER,
                },
                {
                    index: 2,
                    title: 'LinkedIn',
                    icon: 'linkedin',
                    color: '#0e76a8',
                    link: process.env.VUE_APP_LINKEDIN,
                },
                {
                    index: 3,
                    title: 'Facebook',
                    icon: 'facebook',
                    color: '#3b5998',
                    link: process.env.VUE_APP_FACEBOOK,
                }, */
            ],
            items: [
                {
                    index: 0,
                    action: 'navigate',
                    to: {      
                        path: '/',    
                        hash: null
                    },
                    title: 'Accueil',
                    icon: 'home',
                    color: 'green'
                },
                {
                    index: 1,
                    action: 'navigate',
                    to: {
                        path: '/',
                        hash: '#services'         
                    },
                    title: 'Services offerts',
                    icon: 'format-list-bulleted',
                    color: 'light-blue'
                },
                {
                    index: 2,
                    action: 'navigate',
                    to: {
                        path: '/',
                        hash: '#about'         
                    },
                    title: 'À propos de nous',
                    icon: 'information-variant',
                    color: 'light-blue'
                },
                {
                    index: 3,
                    action: 'navigate',
                    to: {
                        path: '/',
                        hash: '#pisé-stabilisé'         
                    },
                    title: `Pisé stabilisé`,
                    icon: 'wall',
                    color: 'blue'
                },
                {
                    index: 4,
                    action: 'navigate',
                    to: {
                        path: '/',
                        hash: '#structures'         
                    },
                    title: `Structures`,
                    icon: 'account-hard-hat',
                    color: 'blue'
                },
                {
                    index: 5,
                    action: 'navigate',
                    to: {
                        path: '/',
                        hash: '#urban-furniture'         
                    },
                    title: 'Mobilier urbain',
                    icon: 'fireplace-off',
                    color: 'pink'
                },
                {
                    index: 6,
                    action: 'navigate',
                    to: {
                        path: '/',
                        hash: '#achievements'         
                    },
                    title: 'Réalisations',
                    icon: 'seal-variant',
                    color: 'pink'
                },
                {
                    index: 7,
                    action: 'navigate',
                    to: {
                        path: '/',
                        hash: '#media-releases'         
                    },
                    title: 'Medias',
                    icon: 'newspaper',
                    color: 'pink'
                },
                {
                    index: 8,
                    action: 'contact',
                    to: {
                        path: '/',
                        hash: '#contact'         
                    },
                    title: 'Nous contacter',
                    icon: 'forum-outline',
                    color: 'red'
                },
            ]
        }
    },
    beforeDestroy () {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.onResize, { passive: true })
        }
    },
    mounted () {
        this.onResize()
        window.addEventListener('resize', this.onResize, { passive: true })
    },
    methods: {
        onResize () {
            this.isMobile = window.innerWidth < 600
        },
        run(method, params = null) {
            if(typeof this[method] === 'function') {
                !!params ? this[method](params) : this[method]()
            }
            else {
                this.$emit('run', method, params)
            }
        },
    },
}
</script>

<style scoped>
.v-btn--floating {
  position: relative;
}
</style>